module.exports = __webpack_public_path__ + "img/icon-dangdifill.052fa2b4.svg";